
import React from 'react';
import Navbar from '../components/Navbar';
import AnimatedBackground from '../components/AnimatedBackground';

const Cookies = () => {
  return (
    <div className="min-h-screen w-full overflow-hidden">
      <AnimatedBackground />
      <Navbar />
      
      <div className="container mx-auto px-4 py-16 relative z-10">
        <div className="max-w-4xl mx-auto bg-black/50 backdrop-blur-lg rounded-xl p-8 border border-white/10 text-left">
          <h1 className="text-3xl font-bold mb-8 text-white">Cookie Policy</h1>
          <p className="text-gray-300 mb-4">Last updated: March 31, 2025</p>
          
          <div className="prose prose-invert max-w-none">
            <p className="text-gray-300 mb-6">
              At Cloudima we use our own cookies to offer you a better user experience. Below we explain what they are, what types we use, and how you can manage them.
            </p>
            
            <h2 className="text-xl font-semibold text-white mt-8 mb-4">1. What are cookies?</h2>
            <p className="text-gray-300 mb-4">
              A cookie is a small file that is stored in your browser when you visit a website. It serves to remember information about your session, preferences, or activity on the site.
            </p>
            
            <h2 className="text-xl font-semibold text-white mt-8 mb-4">2. Types of cookies we use</h2>
            <h3 className="text-lg font-semibold text-gray-100 mt-6 mb-3">Technical cookies (essential)</h3>
            <p className="text-gray-300 mb-4">
              These cookies are necessary for the basic operation of the platform. Without them, Cloudima could not keep your session logged in or remember the state of your projects.
            </p>
            
            <div className="space-y-4 mb-6">
              <div className="bg-white/5 p-4 rounded-lg">
                <p className="font-medium text-white">Name: cloudima-session</p>
                <p className="text-gray-300">Purpose: Maintain the user's session open</p>
                <p className="text-gray-300">Duration: Until you log out or the cookie expires</p>
              </div>
              
              <div className="bg-white/5 p-4 rounded-lg">
                <p className="font-medium text-white">Name: cloudima-project</p>
                <p className="text-gray-300">Purpose: Remember which project/architecture you are working on</p>
                <p className="text-gray-300">Duration: Session or defined project duration</p>
              </div>
            </div>
            
            <h3 className="text-lg font-semibold text-gray-100 mt-6 mb-3">Third-party cookies</h3>
            <p className="text-gray-300 mb-4">
              We currently do not use third-party cookies for analytics or advertising. If this changes, we will inform you and request your consent.
            </p>
            
            <h2 className="text-xl font-semibold text-white mt-8 mb-4">3. Can I disable cookies?</h2>
            <p className="text-gray-300 mb-4">
              You can configure your browser to block or delete cookies, but please note that some Cloudima functionalities may not work correctly if you disable essential cookies.
            </p>
            
            <h2 className="text-xl font-semibold text-white mt-8 mb-4">4. Changes to this policy</h2>
            <p className="text-gray-300 mb-4">
              We may update this policy to reflect technical or legal changes. Check this page periodically to stay informed.
            </p>
            
            <h2 className="text-xl font-semibold text-white mt-8 mb-4">5. Contact</h2>
            <p className="text-gray-300 mb-4">
              If you have questions about our cookie policy, you can write to us at: contact@cloudima.org
            </p>
          </div>
        </div>
      </div>
      
      <footer className="py-8 border-t border-gray-700/30 relative z-10 bg-black/30 backdrop-blur-sm">
        <div className="container px-4 mx-auto">
          <div className="mt-4 text-center">
            <span className="text-sm text-gray-400">© {new Date().getFullYear()} Cloudima. All rights reserved.</span>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Cookies;
